export class IntervalSnapshotTimeoutError extends Error {
  public constructor() {
    super('Interval snapshot request timed out');
  }
}

export class IntervalSnapshotSocketClosedError extends Error {
  public constructor() {
    super('Interval snapshot request failed because the socket was closed');
  }
}
